import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IReminderRepository } from '../../repositories/interfaces/iReminderRepository';
import { IReminderUnSetRequest } from '../../../entity/interface/iReminder';

export interface IUnSetReminderUseCase {
    execute(apikey: string, payload: IReminderUnSetRequest, token: string, identityToken: string): Promise<any>;
}
export class UnSetReminderUseCase implements IUnSetReminderUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get setReminder(): IReminderRepository {
        return container.resolve<IReminderRepository>(DI.REPOSITORIES.IReminderRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apikey: string, payload: IReminderUnSetRequest, token: string, identityToken: string): Promise<any> {
        return await this.setReminder.unSetReminder(apikey, payload, token, identityToken);
    }
}
